<template>
    <div class="xeArea heightMAX rounded" style="overflow: hidden">
        <div class="heightMAX" style="padding: 0">
            <drop @dragover="handleBodyDragOver(...arguments)" @drop="handleBodyDrop(...arguments)"
                class="heightMAX kbet-custom-reset">
                <div class="rounded kbet-widget-energy heightMAX" style="display: block">
                    <p class="title">{{ $t(widget.title) }}</p>
                    <div class="chartHeightMax">
                        <div class="chartHeightMax p-5">
                            <div v-show="viewMode === 'Chart'" ref="chart" style="width: 100%; height: 100%"
                                class="areaChart"></div>
                        </div>
                    </div>
                </div>
            </drop>
        </div>
        <b-modal ref="modalSetting" size="lg" :title="`${$t('설정')} - Area ${$t('차트')}`" bodyClass="p-t-0 p-b-0"
            hide-footer>
            <chart-line-setting :initSetting="chartSetting" :data="chartJs.data" @on-modal-cancel="onModalCancel"
                @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>
<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import * as echarts from "echarts";
import chartLineSetting from "./setting/xeAreaSetting.vue";
import utils from "@src/views/widget/v1/common/xeBaseUtils.js";

export default {
    name: "xeArea",
    extends: xeBaseWidget,
    components: {
        chartLineSetting,
    },
    props: ["cardHeight", "cardWidth"],
    data() {
        return {
            chart: null,
            chartJs: {
                data: {},
            },
            viewMode: "Chart", // 'Chart', 'Grid'
            isGridGroup: false,
            isPagination: false,
            isLineNumber: true,
            gridTable: {
                columns: [],
                rows: [],
            },
            gridSetting: {},
        };
    },
    watch: {
        cardSize() {
            this.chart.resize();
        },
        chartJs: {
            handler() {
                this.renderChart();
            },
            deep: true,
        },
    },
    computed: {
        cardSize() {
            return this.cardHeight * this.cardWidth;
        },
        chartSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
    },
    created() {
        // addition 구조 초기화
        if (!this.widget.addition) {
            this.widget.addition = {
                fixed: 0,
                afterAction: "",
            };
        }

        // chart 기본 구조 초기화
        if (!this.widget.chart) {
            this.widget.chart = {};
        }

        // chart 기본 속성
        if (!this.widget.chart.backgroundColor) {
            this.widget.chart.backgroundColor = "transparent";
        }
        if (!this.widget.chart.chartFontSize) {
            this.widget.chart.chartFontSize = 12;
        }
        if (!this.widget.chart.series) {
            this.widget.chart.series = [];
        }

        // options 구조 초기화
        if (!this.widget.chart.options) {
            this.widget.chart.options = {};
        }

        // legend 구조 초기화
        if (!this.widget.chart.options.legend) {
            this.widget.chart.options.legend = {
                display: true,
                labels: {
                    fontSize: 12,
                    fontColor: "#000000"
                }
            };
        }
        if (!this.widget.chart.options.legend.labels) {
            this.widget.chart.options.legend.labels = {
                fontSize: 12,
                fontColor: "#000000"
            };
        }

        // yAxes 구조 초기화
        if (!this.widget.chart.options.yAxes) {
            this.widget.chart.options.yAxes = {
                left: {
                    display: true,
                    label: "",
                    unit: "",
                    fontSize: 12
                },
                right: {
                    display: false,
                    label: "",
                    unit: "",
                    fontSize: 12
                }
            };
        }
        if (!this.widget.chart.options.yAxes.left) {
            this.widget.chart.options.yAxes.left = {
                display: true,
                label: "",
                unit: "",
                fontSize: 12
            };
        }
        if (!this.widget.chart.options.yAxes.right) {
            this.widget.chart.options.yAxes.right = {
                display: false,
                label: "",
                unit: "",
                fontSize: 12
            };
        }
    },
    mounted() {
        let lines = document.getElementsByClassName("xeArea");
        for (let i = 0; i < lines.length; i++) {
            lines[i].parentNode.style.height = "100%";
        }
        this.$nextTick(() => {
            this.initChart();
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", () => {
            this.chart.resize();
        });
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        initChart() {
            if (this.chart) {
                this.chart.dispose();
            }
            this.$nextTick(() => {
                this.chart = echarts.init(this.$refs.chart);
                this.renderChart();
                setTimeout(() => {
                    if (this.chart) {
                        this.chart.resize();
                    }
                }, 100);
            });
        },
        renderChart() {
            if (!this.chartJs.data || !this.chartJs.data.datasets) {
                return;
            }

            // stacked 옵션 확인
            const isStacked = this.widget.chart.options && this.widget.chart.options.stacked;

            const series = this.chartJs.data.datasets.map((dataset) => ({
                name: dataset.label || "Default",
                type: "line",
                smooth: true,
                symbol: "circle",
                symbolSize: 4,
                showSymbol: true,
                data: dataset.data,
                stack: isStacked ? "total" : undefined, // stacked가 true면 스택 설정
                itemStyle: {
                    color: dataset.backgroundColor || dataset.borderColor,
                },
                lineStyle: {
                    width: dataset.borderWidth || 1.5,
                },
                areaStyle: {
                    color: dataset.backgroundColor || dataset.borderColor,
                    opacity: 0.3,
                },
                yAxisIndex: dataset.yAxisID === "Left_yAxis" ? 0 : 1,
            }));
            const compact = this.isOverviewCompact;
            const option = {
                // backgroundColor: this.widget.chart.backgroundColor || "transparent",
                grid: {
                    left: compact ? "4%" : "9%",
                    right: compact ? "3%" : "5%",
                    bottom: compact ? "8%" : "9%",
                    top: compact ? "22%" : "20%",
                    containLabel: true,
                },
                tooltip: {
                    confine: false,
                    appendToBody: true,
                    trigger: "axis",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    textStyle: {
                        color: "#fff",
                        fontSize: compact ? 10 : 12,
                    },
                    borderWidth: 0,
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985",
                        },
                    },
                    formatter: (params) => {
                        let result = params[0].axisValue + "<br/>";
                        params.forEach((item) => {
                            let value = Number(item.data);
                            result += `${item.marker} ${item.seriesName} : ${this.widget.addition.fixed ? value.toFixed(Number(this.widget.addition.fixed)) : value}<br/>`;
                        });
                        return result;
                    },
                },
                legend: {
                    data: series.map((s) => s.name),
                    show: this.widget.chart.options.legend.display,
                    // 위치 설정 - 상단/하단/좌측/우측 모두 지원
                    orient: this.getLegendOrient(),
                    left: compact ? "center" : this.getLegendLeft(),
                    top: compact ? 2 : this.getLegendTop(),
                    itemGap: compact ? 8 : 12,
                    itemWidth: compact ? 8 : 12,
                    itemHeight: compact ? 8 : 12,
                    icon: "circle",
                    textStyle: {
                        color: this.widget.chart.options.legend.labels.fontColor || "#000000",
                        fontSize: compact
                            ? 9
                            : Number(this.widget.chart.options.legend.labels.fontSize) || 14,
                    },
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: this.chartJs.data.labels || [],
                    axisLabel: {
                        color: this.widget.chart.fontColor || "#000000",
                        fontSize: compact ? 8 : this.widget.chart.chartFontSize || 9,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.widget.chart.gridColor || "#0000001F",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        position: "left",
                        name: compact ? "" : this.widget.chart.options.yAxes.left.label,
                        nameLocation: "middle",
                        nameGap: compact ? 16 : 40,
                        nameRotate: 90,
                        // show: this.widget.chart.options.yAxes.left.display,
                        axisLabel: {
                            color: this.widget.chart.options.yAxes.left.fontColor || "#000000",
                            fontSize: compact
                                ? 8
                                : this.widget.chart.options.yAxes.left.fontSize || 14,
                            show: this.widget.chart.options.yAxes.left.display,
                        },
                        axisLine: {
                            show: this.widget.chart.options.yAxes.left.display,
                            lineStyle: {
                                color: this.widget.chart.gridColor || "#0000001F",
                            },
                        },
                        splitLine: {
                            show: this.widget.chart.options.yAxes.left.display,
                            lineStyle: {
                                color: this.widget.chart.gridColor || "#0000001F",
                            },
                        },
                        nameTextStyle: {
                            color: this.widget.chart.options.yAxes.left.fontColor || "#000000",
                            fontSize: compact
                                ? 8
                                : this.widget.chart.options.yAxes.left.fontSize || 14,
                        },
                    },
                    {
                        type: "value",
                        position: "right",
                        name: compact ? "" : this.widget.chart.options.yAxes.right.label,
                        nameLocation: "middle",
                        nameGap: compact ? 16 : 40,

                        axisLabel: {
                            show: this.widget.chart.options.yAxes.right.display,
                            color: this.widget.chart.options.yAxes.right.fontColor || "#000000",
                            fontSize: compact
                                ? 8
                                : this.widget.chart.options.yAxes.right.fontSize || 14,
                        },
                        axisLine: {
                            show: this.widget.chart.options.yAxes.right.display,
                            lineStyle: {
                                color: this.widget.chart.gridColor || "#0000001F",
                            },
                        },
                        splitLine: {
                            show: this.widget.chart.options.yAxes.right.display,
                            lineStyle: {
                                color: this.widget.chart.gridColor || "#0000001F",
                            },
                        },
                        nameTextStyle: {
                            color: this.widget.chart.options.yAxes.right.fontColor || "#000000",
                            fontSize: compact
                                ? 8
                                : this.widget.chart.options.yAxes.right.fontSize || 14,
                        },
                    },
                ],
                series: series,
            };
            if (this.chart) {
                this.chart.setOption(option);
            }
            window.addEventListener("resize", () => {
                this.chart.resize();
            });
        },
        parse(str) {
            var y = "";
            var m = "";
            var d = "";
            var h = "";
            var M = "";
            var s = "";
            if (/^(\d){8}$/.test(str)) {
                y = str.substr(0, 4);
                m = str.substr(4, 2);
                d = str.substr(6, 2);
                return new Date(y, m, d);
            } else if (/^(\d){10}$/.test(str)) {
                y = str.substr(0, 4);
                m = str.substr(4, 2);
                d = str.substr(6, 2);
                h = str.substr(8, 2);
                return new Date(y, m, d, h);
            } else if (/^(\d){12}$/.test(str)) {
                y = str.substr(0, 4);
                m = str.substr(4, 2);
                d = str.substr(6, 2);
                h = str.substr(8, 2);
                M = str.substr(10, 2);
                s = str.substr(12, 20);
                return new Date(y, m, d, h, M, s);
            }
        },
        getRandomData() {
            let testData = [];
            for (let i = 0; i < 20; i++) {
                testData.push(Math.floor(Math.random() * 100));
            }
            return testData;
        },
        initSetting() {
            this.chartJs.data = {
                labels: this.defaultLabels(this.widget.self.baseline.type),
                datasets: this.defaultDatasets(),
            };
            // this.$el.style.backgroundColor = this.widget.chart.backgroundColor;
            this.renderChart();
        },
        defaultLabels(timeType) {
            let labels = [];
            if (timeType) return labels;
            return labels;
        },
        createLabels(logs) {
            let labels = [];
            let y,
                m,
                d,
                h,
                M = "";
            for (let i = 0; i < logs.length; i++) {
                for (let j = 0; j < logs[i].rows.length; j++) {
                    let str = logs[i].rows[j];
                    if (/^(\d){4}$/.test(str)) {
                        y = str.substr(0, 4);
                        logs[i].rows[j] = y + global.xe.$t("년");
                    } else if (/^(\d){6}$/.test(str)) {
                        y = str.substr(0, 4);
                        m = str.substr(4, 2);
                        logs[i].rows[j] = global.xe.$t(m + "월");
                    } else if (/^(\d){8}$/.test(str)) {
                        y = str.substr(0, 4);
                        m = str.substr(4, 2);
                        d = str.substr(6, 2);
                        logs[i].rows[j] = global.xe.$t(Number(d) + "일");
                    } else if (/^(\d){10}$/.test(str)) {
                        y = str.substr(0, 4);
                        m = str.substr(4, 2);
                        d = str.substr(6, 2);
                        h = str.substr(8, 2);
                        logs[i].rows[j] = h + global.xe.$t("시");
                    } else if (/^(\d){12}$/.test(str)) {
                        y = str.substr(0, 4);
                        m = str.substr(4, 2);
                        d = str.substr(6, 2);
                        h = str.substr(8, 2);
                        M = str.substr(10, 2);
                        logs[i].rows[j] = h + ":" + M;
                    }
                }
            }
            if (logs.length === 1) {
                labels = logs[0].rows;
            } else if (logs.length === 2) {
                let base = logs[0];
                let comp = logs[1];
                if (base.rows.length >= comp.rows.length) {
                    labels = base.rows.map((dt) => [dt]);
                } else {
                    labels = comp.rows.map((dt) => [dt]);
                }
            }
            return labels;
        },
        defaultDatasets() {
            return this.widget.chart.series
                .filter((item) => !item.compare || this.isCompare)
                .map((item) => {
                    return {
                        backgroundColor: item.dataColor,
                        borderColor: item.dataColor,
                        fill: true,
                        label: global.xe.$t(item.label),
                        borderWidth: 1.5,
                        pointRadius: 0,
                        showLine: true,
                        borderCapStyle: "butt",
                        spanGaps: true,
                        yAxisID: item.position === "Left" ? "Left_yAxis" : "Right_yAxis",
                        point: item.point,
                        unit: item.unit,
                        compare: item.compare ? item.compare : false,
                    };
                });
        },
        createDatasets(logs) {
            let datasets = this.defaultDatasets();
            let copyLogs = JSON.parse(JSON.stringify(logs));
            copyLogs = utils.onAfterAction2(datasets, copyLogs, this.widget.addition.afterAction);
            return datasets.map((dataset) => {
                let log = dataset.compare ? copyLogs[1] : copyLogs[0];
                let ptVals = log && log.points ? log.points[dataset.point] : [];
                dataset.data = ptVals;
                return dataset;
            });
        },
        applyData(widgetLogs) {
            let newDatasets = {
                data: {
                    labels: this.createLabels(widgetLogs),
                    datasets: this.createDatasets(widgetLogs),
                },
            };
            this.chartJs.data.labels = newDatasets.data.labels;
            this.chartJs.data.datasets = newDatasets.data.datasets;
            this.renderChart();
            this.widgetLogs = widgetLogs;
        },
        handleDropPoint(transfer) {
            let that = this;
            function append(points) {
                points.map((point) => {
                    if (that.widget.chart.series.filter((v) => v.point === point.ptAddr).length == 0) {
                        that.widget.chart.series.push({
                            type: "spline",
                            label: point.title,
                            point: point.ptAddr,
                            position: "Left",
                            unit: "",
                            backgroundColor: that.getRandomColor(),
                            fill: false,
                        });
                    }
                });
            }
            let defaultObj = {
                type: "spline",
                label: "Default",
                point: "",
                position: "Left",
                backgroundColor: "rgba(52, 143, 226, 0.3)",
                fill: false,
                compare: false,
            };
            if (JSON.stringify(this.widget.chart.series.slice(0, 1)) == JSON.stringify([defaultObj]))
                this.widget.chart.series = [];
            append(transfer.item.type === this.CODE.Drag.PointGroup ? transfer.item.points : [transfer.item]);
        },
        // Legend 위치 설정 메서드들
        getLegendOrient() {
            const position = this.widget.chart.options.legend.position || "top";
            // 좌측/우측일 때는 세로 배치, 상단/하단일 때는 가로 배치
            if (position === "left" || position === "right") {
                return "vertical";
            }
            return "horizontal";
        },
        getLegendLeft() {
            const position = this.widget.chart.options.legend.position || "top";
            const align = this.widget.chart.options.legend.align || "center";

            switch (position) {
                case "left":
                    // 좌측일 때는 align 값에 따라 정렬
                    switch (align) {
                        case "start":
                            return "left";
                        case "center":
                            return "left";
                        case "end":
                            return "left";
                        default:
                            return "left";
                    }
                case "right":
                    // 우측일 때는 align 값에 따라 정렬
                    switch (align) {
                        case "start":
                            return "right";
                        case "center":
                            return "right";
                        case "end":
                            return "right";
                        default:
                            return "right";
                    }
                case "top":
                case "bottom":
                    // 상단/하단일 때는 align 값에 따라 정렬
                    switch (align) {
                        case "start":
                            return "left";
                        case "center":
                            return "center";
                        case "end":
                            return "right";
                        default:
                            return "center";
                    }
                default:
                    return "center";
            }
        },
        getLegendTop() {
            const position = this.widget.chart.options.legend.position || "top";
            const align = this.widget.chart.options.legend.align || "center";

            switch (position) {
                case "top":
                    // 상단일 때는 align 값에 따라 정렬
                    switch (align) {
                        case "start":
                            return "top";
                        case "center":
                            return "top";
                        case "end":
                            return "top";
                        default:
                            return "top";
                    }
                case "bottom":
                    // 하단일 때는 align 값에 따라 정렬
                    switch (align) {
                        case "start":
                            return "bottom";
                        case "center":
                            return "bottom";
                        case "end":
                            return "bottom";
                        default:
                            return "bottom";
                    }
                case "left":
                case "right":
                    // 좌측/우측일 때는 align 값에 따라 정렬
                    switch (align) {
                        case "start":
                            return "top";
                        case "center":
                            return "center";
                        case "end":
                            return "bottom";
                        default:
                            return "center";
                    }
                default:
                    return "top";
            }
        },
        hexToRGBA(hex, alpha) {
            var r = parseInt(hex.slice(1, 3), 16),
                g = parseInt(hex.slice(3, 5), 16),
                b = parseInt(hex.slice(5, 7), 16);
            return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
        },
    },
};
</script>

<style lang="scss" scoped></style>
